import type { Country } from "../Country.js";
import type { Currency } from "../Currency.js";
import type { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";
import type { ProductOfVariantForCustomer } from "../Product.js";
import type { TaxedPrice } from "../TaxedPrice.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";
import { shouldApplyTax } from "./shouldApplyTax.js";

export function getPriceForCustomerOfProductVariant(
	product: ProductOfVariantForCustomer,
	currency: Currency,
	destinationCountry: Country | "outsideEu",
	vatType: EconomicSubjectVatType,
): TaxedPrice {
	const country =
		destinationCountry !== "outsideEu" && isCountryInEuropeanUnion(destinationCountry)
			? destinationCountry
			: "outsideEu";
	const pricesForCurrency = product.variant.prices[currency];
	let price: TaxedPrice | undefined;
	for (const priceForCurrency of Object.values(pricesForCurrency)) {
		if (priceForCurrency.countries.includes(country)) {
			({ price } = priceForCurrency);
			break;
		}
	}
	if (!price) {
		throw new Error(`No price found for currency ${currency} for country ${country}`);
	}
	if (shouldApplyTax(destinationCountry, vatType)) {
		return price;
	}
	return {
		...price,
		taxRate: 0,
		withTax: price.withoutTax,
	};
}
